import loadable from '@loadable/component';
var FlexDocumentController = /** @class */function () {
  function FlexDocumentController() {
    this.pageId = 'FlexDocument';
    this.path = '/doc/:documentName';
    this.legacyPath = '/:localeName/doc/:documentName';
    this.routeName = 'flex-document';
    this.bundles = [];
    this.component = loadable(
    /* istanbul ignore next */
    {
      resolved: {},
      chunkName() {
        return "flex-document";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function () {
        return import(/* webpackChunkName: "flex-document" */'./flex-document.view');
      },
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./flex-document.view");
        }
        return eval('require.resolve')("./flex-document.view");
      }
    });
    this.exact = true;
  }
  FlexDocumentController.prototype.fetch = function (options) {
    var request = options.request,
      stores = options.stores;
    var params = request.params;
    var documentName = params === null || params === void 0 ? void 0 : params.documentName;
    var uiStore = stores === null || stores === void 0 ? void 0 : stores.get('uiStore');
    uiStore === null || uiStore === void 0 ? void 0 : uiStore.setPageName(this.pageId);
    uiStore === null || uiStore === void 0 ? void 0 : uiStore.setDocumentName(documentName);
    return Promise.resolve({});
  };
  FlexDocumentController.prototype.fetchPageData = function () {
    var pageData = {
      title: 'Affiliate Hub',
      seo: {
        robots: 'noindex'
      }
    };
    return Promise.resolve(pageData);
  };
  return FlexDocumentController;
}();
export { FlexDocumentController };